// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedRecord: null
}

const record = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_HOTEL_REQUESTS':
      return { ...state, allData: action.data }
    case 'GET_DATA_HOTEL_REQUESTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_RECORD':
      return { ...state, selectedRecord: action.selectedRecord }
    case 'ADD_RECORD':
      return { ...state }
    case 'EDIT_RECORD':
      return { ...state }  
    case 'DELETE_RECORD':
      return { ...state }
    case 'RESTORE_RECORD':
      return { ...state }
    default:
      return { ...state }
  }
}
export default record
